import { withInstall } from '../../../utils/with-install'
import IconLayer from './IconLayer.vue'

export const ElAmapLocaIcon = withInstall(IconLayer)
export default ElAmapLocaIcon
